(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    var productVariants = $('.product-variants');
    if (productVariants.length > 0) {
      var variants = '';
      $('.product-variant-group').each(function () {
        var $option = $(this).find('.product-variant-wrapper');
        $option.on('click', function () {
          $(this).parents('.product-variant-group').find('.product-variant-wrapper.active').removeClass('active');
          $(this).addClass('active');
          getVariants();
        });
      });
    }
    // product image carousel and modal
    $('.slick-nav .product-slider-image').on('click', function () {
      var thumb = $(this).find('img').attr('src');
      $('.slick-nav .product-slider-image').not(this).removeClass('active-thumb');
      $('.slick-nav .product-slider-image.slick-current').removeClass('slick-current');
      $(this).addClass('active-thumb');
      $('.slick-main img').attr('src', thumb);
    });
    function swapImg(target) {
      var reqImgSrc = target.attr('src');
      $('.modal-main-image img').attr('src', reqImgSrc);
    }
    $('.slick-main img').on('click', function () {
      swapImg($(this));
      var this_src = $(this).attr('src');
      $('#imgModal .modal-thumb img').each(function () {
        if ($(this).attr('src') == this_src) {
          $(this).parent('.modal-thumb').addClass('active-image');
        } else {
          $(this).parent('.modal-thumb').removeClass('active-image');
        }
      });
      $('#imgModal').modal('show');
    });
    $('.modal-thumb img').on('click', function () {
      swapImg($(this));
      $('.modal-thumb img').not(this).parent('.modal-thumb').removeClass('active-image');
      $(this).parent('.modal-thumb').addClass('active-image');
    });

    // open the pricing tab when requested
    function openPricing() {
      $('#pricing-tab').tab('show');
      $('html, body').animate({
        scrollTop: $("#aboutProduct").offset().top
      }, 1300);
    }
    var hash = window.location.hash.substr(1);
    if (hash == 'aboutProduct') {
      openPricing();
    }
    $('#getPricing').on('click', function (e) {
      e.preventDefault();
      openPricing();
    });
    $('#pricing-tab').on('click', function () {});
  });

  function getVariants() {
    var productVariants = $('.product-variants');
    var variant = '';
    if (productVariants.length > 0) {
      $('.product-variant-group').each(function () {
        var label = $(this).find('.product-variant-label').text();
        var varValue = $(this).find('.product-variant-wrapper.active a.btn').text();
        if (varValue.length > 0) {
          variant += label + ': ' + varValue + ' | ';
        }
      });
    }
    $('#input_2_9').val(variant);
  }
});

},{}]},{},[1]);
